import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const { t } = useTranslation();
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              {t('home.latest')}
            </h2>
            <p className="mt-2 text-sm text-foreground-500">{t('home.latest.subtitle')}</p>
          </div>
          <a
            href="/category/loli-culture"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('home.viewAll')}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <a
              key={article.id}
              href={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative overflow-hidden h-48">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-secondary-100 text-secondary-700 text-xs rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base font-bold text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime} 分钟阅读
                  </span>
                  <span>{article.date}</span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <a
            href="/category/loli-culture"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('home.viewAll')}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}